import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Label } from '@jem-open/jem-ui';
import Select from 'react-select';
import { environment } from '../../../../../environment/environment';
import { useMultiProductRecon } from '../MultiProductReconContext';

interface User {
  email: string;
  first_name: string;
  last_name: string;
}

interface EmailRecipientsSectionProps {
  employerId: string;
}

const EmailRecipientsSection = ({
  employerId,
}: EmailRecipientsSectionProps) => {
  const { state, setAttendees } = useMultiProductRecon();

  const [users, setUsers] = useState<User[]>([]);

  useEffect(() => {
    axios
      .get(`${environment.baseUrl}/users/`, {
        params: { employer_id: employerId },
      })
      .then((res) => setUsers(res.data))
      .catch(() => setUsers([]));
  }, [employerId]);

  // Two accounts can share an email (e.g. an old deactivated login); list each
  // address once so picking it can't save the same recipient twice.
  const attendeeOptions = users
    .filter(
      (u, i, all) =>
        all.findIndex(
          (x) => x.email?.toLowerCase() === u.email?.toLowerCase(),
        ) === i,
    )
    .map((u) => {
      const name = [u.first_name, u.last_name].filter(Boolean).join(' ');
      return {
        value: u.email,
        label: name ? `${name} | ${u.email}` : u.email,
      };
    });

  const selectedAttendeeOptions = attendeeOptions.filter((opt) =>
    state.attendees.includes(opt.value),
  );

  return (
    <div className="space-y-1">
      <Label htmlFor="mp-attendees">Send to</Label>
      <Select
        inputId="mp-attendees"
        isMulti
        closeMenuOnSelect={false}
        options={attendeeOptions}
        value={selectedAttendeeOptions}
        onChange={(selected) =>
          setAttendees(selected ? selected.map((s) => s.value) : [])
        }
        placeholder="Select recipients..."
      />
    </div>
  );
};

export default EmailRecipientsSection;
